// libs
import * as React from 'react'

// interfaces / constants

// classes / components
import Notification, { clsHighlightedText, clsText, NotificationProps } from 'src/components/notifications/notification'

// helpers
import Translate, { textResources } from 'src/lang/de'
import DateFormatter from 'src/utils/date_formatter/date_formatter'

// images
import { NotificationsQuery } from '@lopo-tech/lopo-api'
import * as overlayInactive from 'src/components/notifications/badges/Comment@2x.png'
import * as overlayActive from 'src/components/notifications/badges/CommentActive@2x.png'

type Notification = NotificationsQuery['notifications']['items'][number];
type NotificationContentItemType = Extract<
  Notification['resourceLink'],
  { __typename?: 'ContentItemResourceLink' }
>['contentItem']['__typename'];

export type CommentNotificationProps = {
  contentItemTitle: string | null | undefined
  contentItemType: NotificationContentItemType
  createdAt: string;
} & Pick<NotificationProps, 'avatarImage' | 'isRead' | 'onClick' | 'initiatorName'>

const CommentNotification: React.FC<CommentNotificationProps> = ({
  avatarImage,
  contentItemTitle,
  contentItemType,
  createdAt,
  initiatorName,
  isRead,
  onClick
}) => {
  const commentable = contentItemType === 'Event' ? Translate.notifications.commentCommentableType.event : Translate.notifications.commentCommentableType.post

  return (
    <Notification
      avatarImage={avatarImage}
      badgeImageRead={overlayInactive}
      badgeImageNotRead={overlayActive}
      footer={DateFormatter.asTimeAgo(createdAt)}
      initiatorName={initiatorName}
      isRead={isRead}
      onClick={onClick}
    >
      <>
        <span className={clsText} >{` ${textResources.notification.notificationComment} ${commentable}`}</span>
        {contentItemTitle && <strong className={clsHighlightedText} > „{contentItemTitle}“</strong>}
        <span className={clsText} >{` ${textResources.notification.notificationCommented}`}</span>
      </>
    </Notification>
  )
}

export default CommentNotification
